<template>
  <v-container>
    <!-- <v-layout justify-space-between>
      <h1>New Fixed Cost Trip</h1>
    </v-layout>-->
    <v-layout justify-center py-3 row wrap>
      <v-flex xs12 md10 xl8>
        <SimpleCard v-if="!loadingInitialValue">
          <FixedCostAreaDetails
            @submitted="submitted"
            :loading="loading"
            :fixedCostAreaSummary="fixedCost"
          >Fixed Cost #{{$route.params.id}}</FixedCostAreaDetails>
        </SimpleCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Overview from "@/components/settings/Overview.vue";
import FixedCostAreaDetails from "@/components/settings/pricing/FixedCostAreaDetails.vue";
import FixedCostDetails from "@/components/settings/pricing/FixedCostDetails.vue";
import FixedCostCustomerList from "@/components/settings/pricing/FixedCostCustomerList.vue";

import SimpleCard from "@/components/widget/SimpleCard.vue";

import axios from "axios";
axios.defaults.withCredentials = true;

import qs from "qs";

export default {
  name: "fixed_pricing",
  components: {
    Overview,
    FixedCostAreaDetails,
    FixedCostDetails,
    FixedCostCustomerList,
    SimpleCard
  },
  data: function() {
    return {
      loading: false,
      loadingInitialValue: true,
      fixedCost: null,
    };
  },
  mounted: async function() {

    if (this.$route.query.copyFrom == null) {
      this.loadingInitialValue = false;
      return;
    }

    try {
      var url = `${this.$store.state.apiUrl}/fixed_cost/${
        this.$route.query.copyFrom
      }`;

      let response = await axios.get(url, {
        params: {}
      });

      var fixedCost = response.data;

      if (fixedCost.fixed_cost == null) {
        fixedCost.fixed_cost = {};
      }

      if (fixedCost.fixed_cost.fixed_cost_ride_type == null) {
        fixedCost.fixed_cost.fixed_cost_ride_type = [];
      }

      this.fixedCost = response.data;

      var destination = this.fixedCost.destination_location;

      this.fixedCost.destination_location = this.fixedCost.pickup_location;
      this.fixedCost.pickup_location = destination;

      var destination_polygon = this.fixedCost.destination_polygon;

      this.fixedCost.destination_polygon = this.fixedCost.pickup_polygon;
      this.fixedCost.pickup_polygon = destination_polygon;

      this.loadingInitialValue = false;
    } catch (error) {
      this.loadingInitialValue = false;
      console.log("Failed to get fixed costs");
    }

    try {
      var url = `${this.$store.state.apiUrl}/ride_types/all`;

      let response = await axios.get(url, {
        params: {}
      });

      this.rideTypes = response.data;

      console.log("got ride types");
    } catch (error) {
      this.loading = false;
      console.log("Failed to get ride types " + error);
    }
  },
  methods: {
    success: function(data) {
      this.$router.push("/settings/pricing/fixed_cost/" + data.fixed_cost.id);
    },
    failed: function(data) {
      alert("Request Failed with error: " + data.message);
    },
    submitted: function(p) {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${this.$store.state.apiUrl}/fixed_cost/create`;

      if (this.$route.query.copyFrom != null) {
        url += `?copyFrom=${this.$route.query.copyFrom}`
      }


      var completed = this.success;

      axios({
        url: url,
        method: "POST",
        data: qs.stringify(p),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            completed(res.data);
          } else {
            failed(res.data.error);
          }
        })
        .catch(function(err) {
          failed("internal_server_error");
          console.error(err);
        });
    }
  }
};
</script>
